import api from '../api/api';

export const analyzeGrandhotelRoles = async () => {
  console.group('🏨 Analyzing grandhotel user roles');
  
  try {
    // Get current auth state
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (!token) {
      console.error('No auth token found. Please login first.');
      return;
    }
    
    console.log('Current stored user data:', user ? JSON.parse(user) : null);
    
    // Try to get user info from backend
    try {
      const response = await api.get('/auth/user', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      console.log('Backend user data:', response.data);
    } catch (error) {
      console.error('Failed to fetch user from backend:', error);
    }
    
    // Provide fix instructions
    console.log('\n📝 To fix grandhotel roles issue:');
    console.log('1. Clear browser storage and re-login:');
    console.log('   localStorage.clear(); location.href = "/login";');
    console.log('\n2. Or manually update the database to add ROLE_USER to grandhotel');
    console.log('\n3. The issue is that grandhotel was created with only ROLE_VENDOR,');
    console.log('   but the UI expects vendors to also have ROLE_USER for some features.');
    
  } catch (error) {
    console.error('Error analyzing roles:', error);
  } finally {
    console.groupEnd();
  }
};

// Export for console usage
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).analyzeGrandhotelRoles = analyzeGrandhotelRoles;